[
  {
    "id": "8501209d-2281-4b65-8c01-1d2f36f251f0",
    "name": "D41J",
    "address": {
      "countryCode": "DE",
      "regionCode": "DE-NI",
      "city": "Lüneburg",
      "postalCode": "21335",
      "addressLines": ["Am Sande 31"]
    },
    "location": {
      "latitude": 53.248065,
      "longitude": 10.411341
    }
  },
  {
    "id": "bde1209d-2281-4b65-8c01-1d2f36f251f0",
    "name": "D551",
    "address": {
      "countryCode": "DE",
      "regionCode": "DE-NW",
      "city": "Köln",
      "postalCode": "51063",
      "addressLines": ["Schanzenstraße 6-20"]
    },
    "location": {
      "latitude": 50.96609662170518,
      "longitude": 7.015273998156912
    }
  },
  {
    "id": "fff1209d-2281-4b65-8c01-1d2f36f25122",
    "name": "V173",
    "address": {
      "countryCode": "DE",
      "regionCode": "DE-HB",
      "city": "Bremen",
      "postalCode": "28217",
      "addressLines": ["Konsul-Smidt-Straße 20"]
    },
    "location": {
      "latitude": 53.09299832672384,
      "longitude": 8.770602015848414
    }
  },
  {
    "id": "d83f666d-1a36-44ed-a7ed-3293d9f64957",
    "name": "L313"
  },
  {
    "id": "019b1203-5d29-757a-8d50-a5d341ab0850",
    "name": "D4C9",
    "address": {
      "countryCode": "DE",
      "regionCode": "DE-HB",
      "city": "Bremen",
      "postalCode": "28217",
      "addressLines": ["Duckwitzstraße 55"]
    },
    "location": {
      "latitude": 53.09299832672384,
      "longitude": 8.770602015848414
    }
  },
  {
    "id": "019b1201-1a19-751a-8d10-a5d341ab0850",
    "name": "D1JD",
    "address": {
      "countryCode": "DE",
      "regionCode": "DE-BW",
      "city": "Steinen",
      "postalCode": "79585",
      "addressLines": ["Gewerbestrasse 3"]
    },
    "location": {
      "latitude": 47.64079731170918,
      "longitude": 7.747475843666419
    }
  },
  {
    "id": "019b1201-1a19-751a-8d10-a5d341ab5555",
    "name": "zBNT",
    "address": {
      "countryCode": "DE",
      "regionCode": "DE-BY",
      "city": "Berlin",
      "postalCode": "123456",
      "addressLines": ["Buentingstrasse 123"]
    },
    "location": {
      "latitude": 47.64079731170918,
      "longitude": 7.747475843666419
    }
  },
  {
    "id": "019b1201-1a19-751a-8d10-a5d341bc6666",
    "name": "zBC",
    "address": {
      "countryCode": "DE",
      "regionCode": "DE-BY",
      "city": "Berlin",
      "postalCode": "78912",
      "addressLines": ["BuyCountry 42"]
    },
    "location": {
      "latitude": 47.64079731170918,
      "longitude": 7.747475843666419
    }
  }
]